/* eslint-disable guard-for-in */
/* eslint-disable security/detect-object-injection */
/* eslint-disable padding-line-between-statements */
/* eslint-disable camelcase */
/* eslint-disable max-len */
import React, {
    useContext, useCallback, useEffect, useState,useMemo
} from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { withRouter } from 'react-router-dom';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { AccountService } from 'gw-capability-gateway-policy';
import {MLAddressVerificationService, Person, MLPortalSettingsService} from 'gw-capability-quoteandbind';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { AvailabilityService } from 'gw-capability-policycommon';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLContactUtilsService } from 'ml-portals-services-js';
import { MLMultiLobsDataHolderService, MLHistoryService, MLPortalStorageService } from 'ml-services-common-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLEditContactDetailsComponent, MLNameDetailsComponent, MLScriptComponent, SecondaryNamedInsuredComponent, MLAlertGroupComponent, MLPolicyNamedInsuredCandidatesComponent } from 'ml-components-common-react';
import { MLErrorMessageUtil, MLLocalDateUtil, MLProductCodeUtil, MLWizardUtil } from 'ml-portals-util-js';
import { UserService, MLProducerEligibilityService } from 'gw-capability-gateway';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { ClauseService } from 'gw-capability-policycommon';
import moment from 'moment';
import PAWizardConfig from '../../../gw-capability-gateway-quoteandbind-pa-react/config/pa-wizard-config.json5';
import HOWizardConfig from '../../../gw-capability-gateway-quoteandbind-ho-react/config/ho-wizard-config.json5';
import PUPWizardConfig from '../../../gw-capability-gateway-quoteandbind-pup-react/config/pup-wizard-config.json5';
import metadata from './GatewayYourInfoPage.metadata.json5';
import messages from './GatewayYourInfoPage.messages';
import styles from './GatewayYourInfoPage.module.scss';
import PATrackEvent from '../../components/TrackEvent/PATrackEvent';
import HOTrackEvent from '../../components/TrackEvent/HOTrackEvent';
import PUMBTrackEvent from '../../components/TrackEvent/PUMBTrackEvent';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { truncateValue } from '../../../../../../platform/@jutro/data';

const HOP_HOMEOWNERS = 'HOPHomeowners';
const PERSONAL_AUTO = 'PersonalAuto';
const PERSONAL_UMBRELLA = 'PersonalUmbrella';

const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';
const stepNames = {
    [PERSONAL_AUTO]: ['paAccountSync', 'paGroupAssociations', 'paPreFillData'],
    [HOP_HOMEOWNERS]: ['hoAccountSync', 'hoGroupAssociations', 'hoPrequalQuestions'],
    [PERSONAL_UMBRELLA]: ['pupAccountSync', 'pupGroupAssociations', 'pupPrequalQuestions']
};
const stepNamesSkipGroup = {
    [PERSONAL_AUTO]: ['paHVQPreFillDiscrepanciesCheck']
};
const FIRST_WIZARD_PAGE_STEP='gwQuotePAPolicyDetailsPage'


function GatewayYourInfoPage(props) {
    const isGPA = appConfig.portalCode === 'GPA';
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        wizardData: submissionVM,
        updateWizardData,
        currentStep,
        steps,
        changeNextSteps,
        goNext,
        isSkipping,
        history
    } = props;

    const { nextStepVisited, canShowReturnToQuoteButton, isLastStep } = MLWizardNavUtil(props);
    const { initialValidation, onValidate, isComponentValid } = useValidation('GatewayYourInfoPage');
    const translator = useTranslator();
    const [showErrors, updateShowErrors] = useState(false);
    const [showElectronicToPaperWarning, setShowElectronicToPaperWarning] = useState(false);
    const [userType,setUserType]= useState(undefined);
    const [namedInsuredCandidates, updateNamedInsuredCandidates] = useState([]);
    const [showDateOfBirth, updateShowDateOfBirth] = useState(false);
    const [scriptML, updateScriptML] = useState([]);
    const [wasAnalyticsTriggered, updateWasAnalyticsTriggered] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [pniPublicIdInitialisedML, setPNIPublicIdInitialisedML] = useState(false);
    const [originalPNIContactDetails, setOriginalPNIContactDetails] = useState({});
    const [canEditCommFields, setCanEditCommFields] = useState(_.get(submissionVM, 'canEditCommunicationsFields_Ext.value'));
    const [newPrimaryNamedInsuredClicked, setNewPrimaryNamedInsuredClicked] = useState(false);
    const [isBypassCreditOrderingVisible, setBypassCreditOrderingVisible] = useState(false);
    const addressLine1 = _.get(submissionVM, 'baseData.policyAddress.addressLine1.value');
    const city = _.get(submissionVM, 'baseData.policyAddress.city.value');
    const secondaryNamedInsuredValue = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.value');
    const primaryNamedInsured = _.get(submissionVM, 'baseData.primaryNamedInsured_ML')
    const secondaryNamedInsured = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML');
    const primaryNamedInsuredValue = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.value');
    const bypassCreditOrderingValue = _.get(submissionVM, 'baseData.bypassCreditOrdering_Ext.value');
    const isDwellingDeededToBusinessOrTrust = _.get(submissionVM, 'baseData.deedInfo_Ext.value');
    const isHomeOwnersPartialTypeHome =  MLProductCodeUtil.isHomeOwnersPartialTypeHome(submissionVM.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);
    const isHomeOwnersPartialTypeRental =  MLProductCodeUtil.isHomeOwnersPartialTypeRental(submissionVM.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);
    const isHomeOwnersPartialTypeCondo =  MLProductCodeUtil.isHomeOwnersPartialTypeCondo(submissionVM.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);
    const isHomeowners = MLProductCodeUtil.isHomeOwners(submissionVM.baseData.productCode.value);
        const isLLHOrLLC = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(submissionVM.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code)
            || MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(submissionVM.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);
        const isHomeownersAndLLHOrLLC = isHomeowners && isLLHOrLLC;
    const isLandlordHome = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(submissionVM.baseData.productCode.value);
    const isLandlordCondo = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(submissionVM.baseData.productCode.value);
    const [dwellingDeedInfo, setDwellingDeedInfo] = useState(_.get(submissionVM, 'baseData.dwellingDeedInfo_Ext.value'));
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const [canRequote, setCanRequote] = useState(false);
    const [isMVRCacheQuestionVisible, setIsMVRCacheQuestionVisible] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    let returnToQuoteClicked = false;
    const getNewBusinessEffectiveDate = _.get(submissionVM, 'baseData.gafInfo_ML.newBusinessEffectiveDate.value', undefined)
    const ML_STORAGE_KEY_ALREADY_VISITED = "USER_ALREADY_VISITED"
    const state=_.get(submissionVM,'baseData.policyAddress.state.value.code' )
    const [isModernProduct, setIsModernProduct] = useState(false);
    const [newProductStates, updateNewProductStates] = useState([]);
    
    let homeNewProductStates;
    const [homeNewProduct, setHomeNewProducts] = useState([]);
    const [isHOPModernProduct, setIsHOPModernProduct] = useState(false);
    const [occupationtypelist, updateOccupationtypelist] = useState();
    
    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const { MLCustomHistoryTypes ,MLUserTypes } = appConfig;
    const { IA, PCS, GCS_SERVICING, MET_GA } = MLUserTypes;
    const validUserTypes = [IA, PCS, GCS_SERVICING, MET_GA];

    const samePNIAndSNIAlertNameML = 'samePNIAndSNI';
    const {
        clearErrorAlerts,
        addErrorAlert,
        getNumberOfAlerts,
        addWarningAlert,
        clearBlockAlerts
    } = MLNotificationBlockUtil();

    const setCanRequoteFlag = useCallback ( async() => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    const [intialPNI, setIntialPNI] = useState({});
    const [intialSNI, setIntialSNI] = useState({});
    const [enablePNIValidation, setEnablePNIValidation] = useState(false);
    const isQnB = appConfig.portalCode === 'QB';

    useEffect(() => {
        UserService.getCurrentUser(authHeader).then((user) => {
            setUserType(user.userType);
        });
    }, []);

    useEffect(() => {
        if (newProductStates.includes(submissionVM.baseData.policyAddress.state.value.code)) {
            setIsModernProduct(true);
        }
        if(homeNewProduct.includes(submissionVM.baseData.policyAddress.state.value.code)) {
            setIsHOPModernProduct(true);
        }
    }, [newProductStates]);

    useEffect(() => {
            const initOccupationTypeList = () => {
                let categories;
                if (!isHOPModernProduct) return;
                categories = submissionVM.baseData.primaryNamedInsured_ML.occupationType_Ext.aspects.availableValues.filter((value) => {
                    return value.code.endsWith('_np') || value.code === 'military' || value.code === 'other';
                });

                const categoryCodes = categories.map((category) => ({
                    code: category.code,
                    name: translator({
                        id: category.name,
                        defaultMessage: category.name
                    })
                }));

                updateOccupationtypelist(categoryCodes);
            }
    
            initOccupationTypeList();
    
        }, [isHOPModernProduct]);

    useEffect(() => {
        if (_.get(submissionVM, 'baseData.primaryNamedInsured_ML.publicID.value')) {
            setPNIPublicIdInitialisedML(true);
            if (_.isEmpty(intialPNI))
                {
                setIntialPNI(_.cloneDeep(_.get(submissionVM, 'baseData.primaryNamedInsured_ML.value')));
            }
        }
        if (_.get(submissionVM, 'baseData.secondaryNamedInsured_ML.publicID.value')) {
            if (_.isEmpty(intialSNI)) {
                setIntialSNI(_.cloneDeep(_.get(submissionVM, "baseData.secondaryNamedInsured_ML.value")));
            }
        }
        setCanRequoteFlag();
    }, [setCanRequoteFlag, intialPNI, intialSNI, setIntialPNI, setIntialSNI, submissionVM, updateWizardData]);


    useEffect(() => {
    const spIndicator = localStorage.getItem("strategicPartnershipInd_Ext");
    const producerCodeOfRecord_Ext = localStorage.getItem("producerCodeOfRecord_Ext");  
    const referralAgentId = localStorage.getItem("referralAgentId");
    
    const isSP = spIndicator && spIndicator.toLowerCase() === "y";

        if (isSP) {
            const clonedVM = viewModelService.clone(submissionVM);

            _.set(submissionVM, 'baseData.strategicPartnershipInd_Ext.value', true);
            _.set(submissionVM, 'baseData.producerCodeOfRecord_Ext.value', producerCodeOfRecord_Ext);

            if (referralAgentId != null && referralAgentId != "null" && referralAgentId != undefined) {
                _.set(submissionVM, 'baseData.refferalAgentProducerCode.value', referralAgentId);
            }

            updateWizardData(submissionVM);
    }
}, []);

    const doContactsHaveSamePhone = useCallback((accountContact1, accountContact2) => {
        const getPrimaryPhone = (accountContact) => {
            const primaryPhoneType = _.get(accountContact, 'primaryPhoneType');
            switch (primaryPhoneType) {
                case 'home':
                    return accountContact.homeNumber;
                case 'work':
                    return accountContact.workNumber;
                case 'mobile':
                    return accountContact.cellNumber;
                default:
                    return undefined;
            }
        };

        const phoneContact1 = getPrimaryPhone(accountContact1);
        const phoneContact2 = getPrimaryPhone(accountContact2);

        const contact1PrimaryPhoneType = _.get(accountContact1, 'primaryPhoneType');
        const contact2PrimaryPhoneType = _.get(accountContact2, 'primaryPhoneType');
        return contact1PrimaryPhoneType === contact2PrimaryPhoneType
            && phoneContact1
            && phoneContact2
            && phoneContact1 === phoneContact2;
    }, []);

    const showFarmersPrivacyNoticerValue = () => {
        return submissionVM.baseData.productCode.value === "PersonalAuto" || submissionVM.baseData.productCode.value === "PersonalUmbrella" || submissionVM.baseData.productCode.value === "HOPHomeowners";
    }

    const retrieveFarmersPrivacyNoticeValue = () => {
        if(submissionVM.baseData.productCode.value === "PersonalAuto"){
            return _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext');
        }else if(submissionVM.baseData.productCode.value === "PersonalUmbrella"){
            return _.get(submissionVM, 'lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext');
        }else if(submissionVM.baseData.productCode.value === "HOPHomeowners"){
            return _.get(submissionVM, 'lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext');
        }else
            return undefined;
    }

    const prefillHelper = async ( bundleFarmersPrivacyResponse ) => {
        // update the local farmersInsValue and lock the question (update portal storage)
        setFarmersPrivacyNoticeValue(bundleFarmersPrivacyResponse);
        await syncQuestionSets();
        const jsonData = {  alreadyVisited: true };
        MLPortalStorageService.store(submissionVM.quoteID.value, null, ML_STORAGE_KEY_ALREADY_VISITED, JSON.stringify(jsonData), authHeader);
        setPageAlreadyVisited(true);
    }

    const checkSamePhone = doContactsHaveSamePhone(primaryNamedInsuredValue, secondaryNamedInsuredValue);
    const [samePhone, setSamePhone] = useState(checkSamePhone);

    const BOOKROLL_INDICATOR_QUOTE_ASSIST = "quote_assist"
    const BOOKROLL_TYPE_QUOTE_ASSIST = "quote_assist"
    const BOOKROLL_INDICATOR_NO = "no"
    const productCode = _.get(submissionVM, 'baseData.productCode.value');
    const sameMailingAddressValue = _.get(submissionVM, 'baseData.sameMailingAddress_ML.value');
    const priorMailingAddressValue = _.get(submissionVM, 'baseData.priorAddressQuestion_Ext.value');
    const policyAddress = _.get(submissionVM, 'baseData.policyAddress');
    const mailingAddress = _.get(submissionVM, 'baseData.mailingAddress_ML');
    const priorAddress = _.get(submissionVM, 'baseData.priorAddress_Ext');
    const coverageType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', undefined);
    const farmersPrivacyNoticeValueFromVM = retrieveFarmersPrivacyNoticeValue();
    const [farmersPrivacyNoticeValue, setFarmersPrivacyNoticeValue] = useState(null);
    const [quoteAssist, setQuoteAssist] = useState( (submissionVM?.bookrollInd_ML.value === undefined || submissionVM?.bookrollInd_ML.value === null) ? false : submissionVM.bookrollInd_ML.value.code === BOOKROLL_INDICATOR_QUOTE_ASSIST);
    const [questionSetSyncing, setQuestionSetSyncing] = useState(false);
    const [questionSetSyncPromise, setQuestionSetSyncPromise] = useState(null);
    const [pageAlreadyVisited, setPageAlreadyVisited] = useState(false);
    const [displayQuoteAssist, setDisplayQuoteAssist] = useState(false);
    const changeMailingAddressValue = _.get(submissionVM, 'baseData.changeMailingAddQuestion_Ext.value');
    const sniPriorMailingAddressValue = _.get(submissionVM, 'baseData.sniPriorAddressQuestion_Ext.value');
    const sniPriorAddress = _.get(submissionVM, 'baseData.sniPriorAddress_Ext');

    useEffect(() => {
        if(showFarmersPrivacyNoticerValue() && farmersPrivacyNoticeValue === null){
            if(farmersPrivacyNoticeValueFromVM !== undefined || farmersPrivacyNoticeValueFromVM !== null){
                setFarmersPrivacyNoticeValue(farmersPrivacyNoticeValueFromVM);
            }
        }

        if(showFarmersPrivacyNoticerValue() && submissionVM.quoteID.value){
            const storagePromise = MLPortalStorageService.retrieve(submissionVM.quoteID.value, null, ML_STORAGE_KEY_ALREADY_VISITED, authHeader);
            showProgressDialog(platformMessages.synchronizingQuote, storagePromise);
            storagePromise.then( async (response) => {
                let parsedResponse;
                try{
                    parsedResponse = JSON.parse(response);
                    if (parsedResponse.hasOwnProperty('alreadyVisited') && parsedResponse.alreadyVisited === true) {
                        setPageAlreadyVisited(true);
                    }
                }catch(e){
                    console.log(e)
                    //i.e. it is NB, next we will populate the response from existing user response
                    // dafault value is false
                    const bundleFarmersPrivacyResponse = _.get(submissionVM, 'farmersPrivacy_Ext.value');   // check for not null
                    if(submissionVM.isBundle_ML && bundleFarmersPrivacyResponse !== null && bundleFarmersPrivacyResponse !== undefined){  // check if first submission
                        // i.e one draft already have a response, populate the response from there
                        if(submissionVM.baseData.productCode.value === "PersonalAuto"){
                            _.set(submissionVM, "lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext", bundleFarmersPrivacyResponse);
                            await prefillHelper(bundleFarmersPrivacyResponse);
                        }else if(submissionVM.baseData.productCode.value === "PersonalUmbrella"){
                            _.set(submissionVM, 'lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', bundleFarmersPrivacyResponse);
                            await prefillHelper(bundleFarmersPrivacyResponse);
                        }else if(submissionVM.baseData.productCode.value === "HOPHomeowners"){
                            _.set(submissionVM, 'lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', bundleFarmersPrivacyResponse);
                            await prefillHelper(bundleFarmersPrivacyResponse);
                        }
                    }
                }
            })
        }

        LoadSaveService.isProducerCodeApplicableForQuoteAssist_Ext(submissionVM.baseData.producerCode_ML.value ,authHeader).then((response) => {
            if(response){
                setDisplayQuoteAssist(response)
            }
        })
    }, [])

    useEffect(() => {
            MLPortalSettingsService.getSettings(authHeader).then((response)=> {
            if (response) {
                setEnablePNIValidation(response.enablePNIChangeValidation_Ext)
                updateNewProductStates(response.enableAuto50ProductStates);

                //home NP states
                homeNewProductStates = response.enableProperty50ProductStates;
                setHomeNewProducts(homeNewProductStates);

                /*
                DE277404
                */
                let mvrCacheEnabledDate = response.isMVRCacheEnabled
                /*
                 if we have createTime then we know its an existing submission
                 else we treat it a new submission and use current date
                 */
                const createTime = submissionVM.createTime.value
                        if(createTime){
                    let enabledCache = moment(createTime).startOf('day').isSameOrAfter(moment(mvrCacheEnabledDate).startOf('day'));
                    setIsMVRCacheQuestionVisible(enabledCache);
                }
                        else{
                    let createDate = new Date()
                    let enabledCache = moment(createDate).startOf('day').isSameOrAfter(moment(mvrCacheEnabledDate).startOf('day'));
                    setIsMVRCacheQuestionVisible(enabledCache);
                }
            }
        });
    }, [authHeader]);

    let wizardSteps;
    if (productCode === PERSONAL_AUTO) {
        wizardSteps = PAWizardConfig.steps;
    } else if (productCode === HOP_HOMEOWNERS) {
        wizardSteps = HOWizardConfig.steps;
    } else {
        wizardSteps = PUPWizardConfig.steps;
    }

    if (!primaryNamedInsuredValue) {
        submissionVM.baseData.primaryNamedInsured_ML.value = submissionVM.baseData.accountHolder.value;
    }

    const isBookrollSubmission = (submission) => {
        return submission.bookrollInd_ML === BOOKROLL_WITH_RATE_CAPPING || submission.bookrollInd_ML === BOOKROLL_WITHOUT_RATE_CAPPING;
    };

    const isBundleRateCapped = (submission) => {
        return submission.rateCapped_Ext || submission.bookrollInd_ML === BOOKROLL_WITH_RATE_CAPPING;
    }

    const checkOwnedLessThanSixMonths = (vehicleVM) => {
        if (!vehicleVM.purchaseDate_ML) {
            vehicleVM.ownedLessThan6Months_Ext = false;
            return;
        }

        const effectiveDate = _.get(submissionVM, 'baseData.periodStartDate.value', {});

        const effectiveMonth = effectiveDate.month + 1;
        const currentYear = new Date().getFullYear();

        if (vehicleVM.purchaseDate_ML.year === currentYear - 1) {
            if (effectiveMonth < 6) {
                vehicleVM.ownedLessThan6Months_Ext = true;
            } else {
                vehicleVM.ownedLessThan6Months_Ext = false;
            }
        } else if (vehicleVM.purchaseDate_ML.year === currentYear) {
            if (effectiveMonth > 6) {
                vehicleVM.ownedLessThan6Months_Ext = true;
            } else {
                vehicleVM.ownedLessThan6Months_Ext = true;
            }
        } else {
            vehicleVM.ownedLessThan6Months_Ext = false;
        }
    };    

    const assignRegisteredOwnersToVehicles = (submissionVM) => {
        const coverables = _.get(submissionVM, 'lobData.personalAuto.coverables');
        if (!coverables) return;

        const drivers = _.get(coverables, 'drivers.children', []);
        const vehicles = _.get(coverables, 'vehicles.children', []);

        const selfDriver = _.find(
            drivers,
            d => _.get(d, 'relationshipToInsured_ML.value.code') === 'self'
        );

        const driverID = _.get(selfDriver, 'fixedId.value');
        if (!driverID) return;

        _.forEach(vehicles, vehicle => {
            const vehicleID = _.get(vehicle, 'fixedId.value');
            if (!vehicleID) return;

            const registeredOwners = _.get(vehicle, 'registeredOwners.value');

            if (_.isEmpty(registeredOwners)) {
                vehicle.registeredOwners = [{ driverID, vehicleID }];
            }
        });
    };
    
    const skipOnResumeIf = () => {
        console.log('LastVisited Step entering skipping logiC: ', MLMultiLobsDataHolderService.getLastVisitedStep())
        const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)

        if (jumpToQuote) {
            //Default bypassCreditOrdering_Ext if it is not set
            if (!_.get(submissionVM, 'baseData.bypassCreditOrdering_Ext.aspects.valid')) {
                _.set(submissionVM, 'baseData.bypassCreditOrdering_Ext.value', false)                
            }

            let submissionValid = true;

            if (productCode === PERSONAL_AUTO) {            
                // Need to check if drivers and vehicles are valid, as well as
                // the rest of the submission before proceeding.
                const vehicleList = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles', []);
                const driverList = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value', []);

                // Set edit flag to true so validations are run on drivers and vehicles
                driverList.forEach((driver) => {
                    driver.editMode_ML = true;            
                });
                vehicleList.forEach((vehicle) => {
                    // Default ownership check for vehicles
                    checkOwnedLessThanSixMonths(vehicle.value);
                    vehicle.editMode_ML = true;
                });

                // Initial JDP quotes will not assign registered owners to vehicles automatically,
                // so we need to do it manually here.
                assignRegisteredOwnersToVehicles(submissionVM);            

                submissionValid= submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;

                // Set edit flag back to false after validation
                driverList.forEach((driver) => {
                    driver.editMode_ML = false;
                });
                vehicleList.forEach((vehicle) => {
                    vehicle.editMode_ML = false;
                });
            } 
            
            if (!submissionValid) {
                return false;
            }
            
            return initialValidation().then((isValid) => !!isValid);
        } else {

            if (!!_.get(submissionVM, 'bindData.policyNumber.value')
                && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
                return true;
            }

            if (productCode === PERSONAL_AUTO
                && _.get(submissionVM, 'value.baseData.policyAddress.state') === 'AK' && _.get(submissionVM, 'value.baseData.termType') === '7Days') {
                return true;
            }

            if (isBundleRateCapped(submissionVM.value)) {
                return true;
            }

            if ((MLMultiLobsDataHolderService.getLastVisitedStep() === undefined
                || MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName)
                && (!submissionVM.hvqQuoteID_ML.value || !submissionVM.baseData.accountHolder.emailAddress1.value)) {
                return false;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep(submissionVM.quoteID.value) === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }

            if (submissionVM.hvqQuoteID_ML.value) {
                return MLMultiLobsDataHolderService.hasCompletedStep(currentStep.mlStepName);
            }

            // DE228805 - Commenting out while phone number is not required
            /* if (checkPhoneNumberEntered() === true ||  _.get(submissionVM, 'baseData.primaryNamedInsured_ML.primaryPhoneType.aspects.valid') === false){
                console.log('stopping on YourInfo page because phone number is invalid')
                return false;
            } */        

            console.log('Skpping YourInfo page becuase everything is valid');
            return true;
        }
    };

    const setInitialPNIContactDetails = () => {
        const homeNumber = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.homeNumber.value')
        const cellNumber = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.cellNumber.value')
        const workNumber = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.workNumber.value')

        setOriginalPNIContactDetails({
            originalEmailAddress: _.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value'),
            // When new contacts are added as PNI, the phone number is defaulted to 'a'.  See addNewContact function
            originalHomeNumber: (homeNumber === 'a') ? undefined : homeNumber,
            originalCellNumber: (cellNumber === 'a') ? undefined : cellNumber,
            originalWorkNumber: (workNumber === 'a') ? undefined : workNumber,
        });
    };

    useEffect(() => {
        const changeNextStepToQuotePage = () => {
            // go to quoteDetails
            const index = _.findIndex(
                steps,
                ({ path }) => path === '/quote'
            );
            if (index > 0) {
                const remainingSteps = _.slice(steps, index);
                changeNextSteps(remainingSteps);
            }
        }

        if (isBundleRateCapped(submissionVM.value)) {
            if (submissionVM.value.isQuoted()) {
                changeNextStepToQuotePage();
            } else {
                Promise.reject();
            }
        } else if (productCode === PERSONAL_AUTO && _.get(submissionVM, 'value.baseData.policyAddress.state') === 'AK' && _.get(submissionVM, 'value.baseData.termType') === '7Days') {
            if (submissionVM.value.isQuoted() && !submissionVM.value.hasRateAsOfDateExpired()){
                changeNextStepToQuotePage();
            } else  {
                Promise.reject();
            }
        }

        if (!nextStepVisited()) {
            setInitialPNIContactDetails();
        }

        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadNamedInsuredCandidates = useCallback((isForSNI = false) => {
        const namedInsuredCandidatesPromise = AccountService.getNamedInsuredCandidatesML(
            submissionVM.baseData.accountNumber.value,
            submissionVM.baseData.productCode.value,
            authHeader
        );
        showProgressDialog(platformMessages.loading, namedInsuredCandidatesPromise, true);
        namedInsuredCandidatesPromise
            .then((candidates) => {
                if (candidates && candidates.length > 0) {
                    const candidatesObjectArr = candidates.map((candidate) => viewModelService.create(Person.createFromAccountContact(candidate), 'pc',
                        'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO'));
                    const candidatesVM = candidatesObjectArr.map((candidateVM) => candidateVM.value);
                    updateNamedInsuredCandidates([...candidatesVM]);

                    // There is no publicID on accountHolder if this is the first submission after the account is created
                    if (!isForSNI) {
                        const primaryInsuredPublicID = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.publicID.value');
                        const selectedCandidate = primaryInsuredPublicID ? candidatesVM.find((candidate) => candidate.publicID === primaryInsuredPublicID) : candidatesVM[0];

                        if (selectedCandidate) {
                            const currentPrimaryInsured = submissionVM.baseData.primaryNamedInsured_ML.value;
                            const refreshedPrimaryInsured = { ...selectedCandidate };

                            // Preserve quote-specific answers when refreshing the current insured.
                            ['educationLevel_ML', 'occupationType_Ext'].forEach((field) => {
                                const currentValue = _.get(currentPrimaryInsured, field);
                                if (!_.isNil(currentValue) && currentValue !== '') {
                                    refreshedPrimaryInsured[field] = currentValue;
                                }
                            });

                            submissionVM.baseData.primaryNamedInsured_ML.value = refreshedPrimaryInsured;
                        }
                    }

                    if (candidates.length === 1) {
                        submissionVM.baseData.accountHolder.value = submissionVM.baseData.primaryNamedInsured_ML.value;
                    }
                } else {
                    submissionVM.baseData.primaryNamedInsured_ML = submissionVM.baseData.accountHolder;
                }
                updateWizardData(submissionVM);
            })
            .catch(() => {
                updateNamedInsuredCandidates([]);
            });
    }, [authHeader, showProgressDialog, submissionVM, updateWizardData, viewModelService]);

    const getCanEditCommFieldsFromAccount = () => {
        const accountNumber = _.get(submissionVM, 'baseData.accountNumber.value');
        if (accountNumber) {
            const canEditPromise = AccountService.canEditCommunicationsFields(
                accountNumber,
                authHeader
            );
            //showProgressDialog(platformMessages.loading, canEditPromise, true);
            canEditPromise.then((res) => {
                setCanEditCommFields(res);
            })
        }
    };

    const validateEmailAddress = (accountContactDetailsVm) => {
        const account = accountContactDetailsVm;
        let emailAddress1 =  _.get(account, 'emailAddress1.value');
        if(emailAddress1){
            emailAddress1=emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification Api Called");
                if(res == true){
                    _.set(account, 'emailVerified_Ext.value', true);
                    _.set(account, 'emailAddress1.value', emailAddress1);
                }
                else{
                    _.set(account, 'emailVerified_Ext.value', false);
                    _.set(account, 'emailAddress1.value', emailAddress1 + " ");
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(messages.invalidEmail), 'invalidEmail');
                _.set(account, 'emailVerified_Ext.value', false);
                _.set(account, 'emailAddress1.value', emailAddress1);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }

    };

    const checkUserCode = useCallback((user) => {
        const clonedSubmissionVM = _.clone(submissionVM);

        if(user) {
            if (user?.primaryProducerCode_ML?.code?.startsWith('9SM')) {
                setBypassCreditOrderingVisible(true)
                _.isUndefined(_.get(submissionVM, 'baseData.bypassCreditOrdering_Ext.value')) && _.set(clonedSubmissionVM, 'baseData.bypassCreditOrdering_Ext.value', true)
            } else {
                setBypassCreditOrderingVisible(false)
                _.set(clonedSubmissionVM, 'baseData.bypassCreditOrdering_Ext.value', false)
            }

            updateWizardData(clonedSubmissionVM)
        }
    }, [submissionVM, updateWizardData])

    useEffect(() => {
        // if (submissionVM.isBundle_ML && submissionVM.isBundle_ML.value) {
        //     ctrl._refreshBundleWidget();
        // }

        if ((!isSkipping || (isSkipping && !skipOnResumeIf())) && !nextStepVisited()) {
            if (productCode === PERSONAL_AUTO) {
                submissionVM.baseData.termType = 'HalfYear';
            }


            loadNamedInsuredCandidates();

            if (canEditCommFields === undefined) {
                getCanEditCommFieldsFromAccount();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        LoadSaveService.getScript(
            "FirstWizardPage",
            {
                state: _.get(submissionVM, "baseData.policyAddress.state.value.code")

            },
            authHeader,
        ).then((lines) => {
            if (isLLHOrLLC && (lines.length > 1)) {
                updateScriptML([lines[1]]);
            }
            else if (lines.length > 0) {
                updateScriptML([lines[0]]);
            }
            else {
                updateScriptML(lines);
            }
        });
    }, []);


    useEffect(() => {
        if (!nextStepVisited()) {
            if (sessionStorage.getItem('QuoteStarted') === "true" && isGPA) {
                UserService.getCurrentUser(authHeader).then((user) => {
                    if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                        PUMBTrackEvent('Quote Started', isSkipping, submissionVM, user, { });
                    }
                    else if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                        HOTrackEvent('Quote Started', isSkipping, submissionVM, user, { });
                    }
                    else {
                        PATrackEvent('Quote Started', isSkipping, submissionVM, user, { });
                    }

                    sessionStorage.removeItem('QuoteStarted');
                    checkUserCode(user);
                });
            }
        }
    }, []);

    useEffect(() => {
        if (!nextStepVisited()) {
            if (sessionStorage.getItem('QuoteRetrieved') === "true" && isGPA) {
                UserService.getCurrentUser(authHeader).then((user) => {
                    if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                        PUMBTrackEvent('Quote Retrieved', isSkipping, submissionVM, user, { });
                    }
                    else if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                        HOTrackEvent('Quote Retrieved', isSkipping, submissionVM, user, { });
                    }
                    else {
                        PATrackEvent('Quote Retrieved', isSkipping, submissionVM, user, { });
                    }

                    sessionStorage.removeItem('QuoteRetrieved');
                    checkUserCode(user);
                });
            }
        }
    }, []);
    
    useEffect(() => {
        if (_.isUndefined(_.get(submissionVM, 'baseData.deedInfo_Ext.value'))) {
            _.set(submissionVM, 'baseData.deedInfo_Ext.value', false);
            updateWizardData(submissionVM);
        }
    }, [])

    const writeValue = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
                 updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const onContactCandidateChange = useCallback((value) => {
        updateShowDateOfBirth(false);
        const selectedCandidate = namedInsuredCandidates.find((candidate) => candidate.publicID.value === value);
        writeValue(selectedCandidate.value, 'baseData.primaryNamedInsured_ML.value');
    }, [writeValue, updateShowDateOfBirth, namedInsuredCandidates]);

    const addNewContact = useCallback(() => {
        const emptyContact = {
            subtype: 'Person',
            accountHolder: false,
            primaryAddress: submissionVM.baseData.policyAddress.value,
            primaryNamedInsured_ML: true,
            homeNumber: 'a', // passing unallowed character to clear the InputMask component html on screen. PD team fixed this bug in ver6.4
            workNumber: 'a',
            cellNumber: 'a'
        };
        _.set(submissionVM, 'baseData.primaryNamedInsured_ML.value', emptyContact);
        updateShowDateOfBirth(true);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const clearNewContactPhone = useCallback(() => {
        // Once InputMask is cleared - reset input values to empty string so fields arent validated
        _.set(submissionVM, 'baseData.primaryNamedInsured_ML.homeNumber.value', '');
        _.set(submissionVM, 'baseData.primaryNamedInsured_ML.cellNumber.value', '');
        _.set(submissionVM, 'baseData.primaryNamedInsured_ML.workNumber.value', '');
        updateWizardData(submissionVM);
        setNewPrimaryNamedInsuredClicked(true);
    }, [submissionVM, updateWizardData]);


    const setPrimaryNamedInsuredML = useCallback((insuredCandidate) => {
        if (insuredCandidate) {
            updateShowDateOfBirth(false);
            writeValue(insuredCandidate, 'baseData.primaryNamedInsured_ML.value');
        } else {
            addNewContact();
        }

        setInitialPNIContactDetails();

        if (_.isUndefined(insuredCandidate)) {
            clearNewContactPhone();
        }
    }, [writeValue, addNewContact, clearNewContactPhone]);

    const syncAddresses = (fromAddress, toAddress) => {
        _.set(toAddress, 'addressLine1', fromAddress.addressLine1);
        _.set(toAddress, 'addressLine2', fromAddress.addressLine2);
        _.set(toAddress, 'city', fromAddress.city);
        _.set(toAddress, 'state', fromAddress.state);
        _.set(toAddress, 'postalCode', fromAddress.postalCode);
        _.set(toAddress, 'country', fromAddress.country);
        _.set(toAddress, 'displayName', fromAddress.displayName);
    };

    const createNewAddress = () => {
        const policyAddressValue = policyAddress.value;
        const addressObj = {
            displayName: policyAddressValue.displayName,
            state: policyAddressValue.state,
            city: policyAddressValue.city,
            postalCode: policyAddressValue.postalCode,
            country: policyAddressValue.country,
            addressLine1: policyAddressValue.addressLine1,
            addressLine2: policyAddressValue.addressLine2
        };
        return viewModelService.create(addressObj, 'pc', 'edge.capabilities.address.dto.AddressDTO');
    };

    useEffect(() => {
        if (isGPA && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Your Info Page' });
                }
                else if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Your Info HO Page' });
                }
                else {
                    PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Your Info Page' });
                }

                if (!nextStepVisited()) {
                    checkUserCode(user);
                }
            });
        }
    }, []);

    useEffect(() => {
        setTimeout(()=>{
            const element = document.getElementById("choosePrimaryNamedInsuredContainer");
            if(element){
                element.focus();
            }
        }, 100)
    }, []);   

    useEffect(() => {
        if ((!isSkipping || (isSkipping && !skipOnResumeIf())) && !nextStepVisited()) {
            const clonedSubmissionVM = _.clone(submissionVM);
            if (MLProductCodeUtil.isHomeOwners(productCode) && _.isUndefined(clonedSubmissionVM.lobData.homeowners.coverables.policyAddress.value)) {
                const newPolicyAddress = createNewAddress();
                _.set(clonedSubmissionVM, 'lobData.homeowners.coverables.policyAddress.value', newPolicyAddress.value);
            }

            if (_.isUndefined(sameMailingAddressValue)) {
                _.set(clonedSubmissionVM, 'baseData.sameMailingAddress_ML.value', true);
            }

            if (_.isUndefined(mailingAddress.value)) {
                const newMailingAddress = createNewAddress();
                _.set(clonedSubmissionVM, 'baseData.mailingAddress_ML.value', newMailingAddress.value);
            }

            if (_.isUndefined(priorMailingAddressValue)) {
                _.set(clonedSubmissionVM, 'baseData.priorAddressQuestion_Ext.value', false);
            }

            if (_.isUndefined(sniPriorMailingAddressValue)) {
                _.set(clonedSubmissionVM, 'baseData.sniPriorAddressQuestion_Ext.value', false);
            }

            if (isLLHOrLLC) {
                _.set(clonedSubmissionVM, 'baseData.priorAddressQuestion_Ext.value', false);
                _.set(clonedSubmissionVM, 'baseData.sniPriorAddressQuestion_Ext.value', false);
            } else if (_.isUndefined(priorMailingAddressValue)) {
                _.set(clonedSubmissionVM, 'baseData.priorAddressQuestion_Ext.value', false);
            } else if (_.isUndefined(sniPriorMailingAddressValue)) {
                _.set(clonedSubmissionVM, 'baseData.sniPriorAddressQuestion_Ext.value', false);
            }

            if (priorAddress.value && priorAddress.value.postalCode) {
                _.set(clonedSubmissionVM, 'baseData.priorAddress_Ext.value', priorAddress.value);
            } else {
                priorAddress.value = {
                    addressLine1: policyAddress.addressLine1.value,
                    addressLine2: policyAddress.addressLine2.value,
                    displayName: policyAddress.displayName.value,
                    state: policyAddress.state.value.code,
                    city: policyAddress.city.value,
                    postalCode: policyAddress.postalCode.value,
                    country: policyAddress.country.value.code
                };
            }

            if (sniPriorAddress.value && sniPriorAddress.value.postalCode) {
                _.set(clonedSubmissionVM, 'baseData.sniPriorAddress_Ext.value', sniPriorAddress.value);
            } else {
                sniPriorAddress.value = {
                    addressLine1: policyAddress.addressLine1.value,
                    addressLine2: policyAddress.addressLine2.value,
                    displayName: policyAddress.displayName.value,
                    state: policyAddress.state.value.code,
                    city: policyAddress.city.value,
                    postalCode: policyAddress.postalCode.value,
                    country: policyAddress.country.value.code
                };
            }

            _.set(clonedSubmissionVM, 'isSubmitAgent.value', true);
            updateWizardData(clonedSubmissionVM);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let dataHasChanged = false;
        const clonedSubmissionVM = _.clone(submissionVM);

        if (MLProductCodeUtil.isHomeOwners(productCode)) {
            if (!MLWizardUtil.areAddressesEqual(policyAddress.value, submissionVM.lobData.homeowners.coverables.policyAddress.value)) {
                syncAddresses(policyAddress, clonedSubmissionVM.lobData.homeowners.coverables.policyAddress);
                dataHasChanged = true;
            }
        }

        if (sameMailingAddressValue) {
            if (!MLWizardUtil.areAddressesEqual(policyAddress.value, submissionVM.baseData.mailingAddress_ML.value)) {
                syncAddresses(policyAddress, clonedSubmissionVM.baseData.mailingAddress_ML);
                dataHasChanged = true;
            }
        }

        if (!priorMailingAddressValue) {
            if (!MLWizardUtil.areAddressesEqual(policyAddress.value, submissionVM.baseData.priorAddress_Ext.value)) {
                syncAddresses(policyAddress, clonedSubmissionVM.baseData.priorAddress_Ext);
                dataHasChanged = true;
            }
        }

        if (dataHasChanged) {
            updateWizardData(clonedSubmissionVM);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [policyAddress]);

    // show error alert when PNI and SNI are the same contact
    useEffect(() => {
        clearErrorAlerts();
        if (primaryNamedInsuredValue && primaryNamedInsuredValue.publicID &&
            secondaryNamedInsuredValue && secondaryNamedInsuredValue.publicID &&
            primaryNamedInsuredValue.publicID === secondaryNamedInsuredValue.publicID) {
            addErrorAlert(messages.SNIAndPNICannotBeTheSameContactML, samePNIAndSNIAlertNameML);
            window.scrollTo(0, 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [primaryNamedInsuredValue, secondaryNamedInsuredValue]);

    useEffect(() => {
        if ((_.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code') === 'electronic') && !_.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value')) {
            addWarningAlert(translator(messages.electronicToPaperWarning), 'electronicToPaper');
            setShowElectronicToPaperWarning(true);
            window.scrollTo(0, 0);
        }
    }, []);

    const handleEligibilityError = (data) => {
        clearBlockAlerts("producerEligibility");    
        const defaultReason = translator(messages.selectDiffProducerCode);
        const reasonToShow = data.nonEligibleReason ? data.nonEligibleReason: defaultReason;
        addErrorAlert(translator(reasonToShow), 'producerEligibility');
    };

    const requestProducerEligibility = async () => {
      const req = {
        state: submissionVM.baseData.policyAddress.state.value.code,
        producerCodeCode: submissionVM.value.baseData.producerCode_ML,
        policyStatus: "New",
        skipGroupEligibilityCheck: false,
      };

      try {
        clearBlockAlerts("producercodechanged");

        const eligibilityPromise =MLProducerEligibilityService.isProducerCodeEligible(req, authHeader);

        showProgressDialog(platformMessages.checkingProducerCodeEligibility, eligibilityPromise);

        const data = await eligibilityPromise;

        if (!data.isEligible || !_.isUndefined(data.nonEligibleReason)) {
          handleEligibilityError(data);

          return false;
        }

        if (data.isEligible && req.producerCodeCode !== data.producerCodeCode) {
          _.set(submissionVM,"value.baseData.producerCode_ML",data.producerCodeCode,);
          _.set(submissionVM, "value.baseData.producerAutoUpdated_Ext", true);
          // Clear producerCodeOfRecord so sidebar will refetch fresh data
          _.set(submissionVM, "producerCodeOfRecord_ML.value", {});
          updateWizardData(submissionVM);
          addWarningAlert(translator(messages.producerCodeChanged), 'producercodechanged');
        }
      } catch (error) {
        console.error(error);
        handleEligibilityError(error);
        return false;
      }
    };

    useEffect(() => {
        if(!skipOnResumeIf()){
            requestProducerEligibility();
        }
    }, []);

    const updateMailingAddress = useCallback(() => {
        const flag = !sameMailingAddressValue;
        const clonedSubmissionVM = _.clone(submissionVM);
        _.set(clonedSubmissionVM, 'baseData.sameMailingAddress_ML.value', flag);
        if (flag) {
            syncAddresses(policyAddress, clonedSubmissionVM.baseData.mailingAddress_ML);
        } else {
            clonedSubmissionVM.baseData.mailingAddress_ML = {};
        }
        updateWizardData(clonedSubmissionVM);
    }, [policyAddress, sameMailingAddressValue, submissionVM, updateWizardData]);

    const updateFarmersPrivacyNotice = useCallback((newValue) => {
        setFarmersPrivacyNoticeValue(newValue);
    }, []);

    const updateQuoteAssist = (newValue) => {
        const clonedSubmissionVM = _.clone(submissionVM);
        if(newValue){
            _.set(clonedSubmissionVM, "bookrollInd_ML.value", BOOKROLL_INDICATOR_QUOTE_ASSIST)
            _.set(clonedSubmissionVM, "bookRollType_Ext.value", BOOKROLL_TYPE_QUOTE_ASSIST)
        }else{
            _.set(clonedSubmissionVM, "bookrollInd_ML.value", BOOKROLL_INDICATOR_NO)
        }
        updateWizardData(clonedSubmissionVM);
        setQuoteAssist(newValue)
    };

    const showQuoteAssistQuestion = () => {
        const bookrollInd = submissionVM?.bookrollInd_ML.value;
        const flagFromPC = displayQuoteAssist
        console.log(bookrollInd)
        console.log(flagFromPC)
        // if bookrollInd is undefined and no QuoteID and script params allow to display i.e. submission is new, display question
        if(flagFromPC && (bookrollInd === undefined || bookrollInd.code === BOOKROLL_INDICATOR_NO))
            return true
        else if(flagFromPC && (bookrollInd.code === BOOKROLL_INDICATOR_QUOTE_ASSIST || bookrollInd.code === BOOKROLL_INDICATOR_NO))
            return true
        else
            return false
    }

    const updatePriorAddress = useCallback(() => {
        const flag = !priorMailingAddressValue;
        const clonedSubmissionVM = _.clone(submissionVM);
        _.set(clonedSubmissionVM, 'baseData.priorAddressQuestion_Ext.value', flag);
        if (!flag) {
            syncAddresses(policyAddress, clonedSubmissionVM.baseData.priorAddress_Ext);
            syncAddresses(policyAddress, clonedSubmissionVM.baseData.sniPriorAddress_Ext);
        } else {
            clonedSubmissionVM.baseData.priorAddress_Ext = {};
        }
        updateWizardData(clonedSubmissionVM);
    }, [policyAddress, priorMailingAddressValue, submissionVM, updateWizardData]);

    const updateContactVM = () => {
        updateWizardData(submissionVM);
    };

    const onChangeBypassCreditOrdering = useCallback(() => {
        const flag = !bypassCreditOrderingValue;
        const clonedSubmissionVM = _.clone(submissionVM);

        _.set(clonedSubmissionVM, 'baseData.bypassCreditOrdering_Ext.value', flag);
        updateWizardData(clonedSubmissionVM);
    }, [bypassCreditOrderingValue, submissionVM, updateWizardData]);

    const setCurrentStepName = useCallback(() => {
        if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'paContactDetails');
        } else if (MLProductCodeUtil.isHomeOwners(productCode)) {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'hoContactDetails');
        } else if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'pupContactDetails');
        }
    }, [productCode, submissionVM]);

    const setDefaultPrimaryPhone = useCallback(() => {
        MLContactUtilsService.setDefaultPrimaryPhone(submissionVM.baseData.primaryNamedInsured_ML);

        if (secondaryNamedInsuredValue && samePhone) {
            _.set(submissionVM, 'baseData.secondaryNamedInsured_ML.primaryPhoneType', submissionVM.baseData.accountHolder.primaryPhoneType);
        }
        updateWizardData(submissionVM);
    }, [samePhone, secondaryNamedInsuredValue, submissionVM, updateWizardData]);

    const syncPrimaryInsuredNameAndEmailWithDrivers = useCallback(() => {
        if (!MLProductCodeUtil.isPersonalAuto(productCode) || !_.get(submissionVM, 'lobData.personalAuto.coverables.drivers')) {
            return;
        }
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value')
        if (drivers && drivers.length) {
            const primaryNamedDriver = drivers.find((driver) => driver.relationshipToInsured_ML === 'self');
            if (primaryNamedDriver && primaryNamedDriver.person && (primaryNamedDriver.person.publicID === primaryNamedInsured.publicID.value)) {
                primaryNamedDriver.person.emailAddress_ML = primaryNamedInsured.emailAddress1.value;
                primaryNamedDriver.person.firstName = primaryNamedInsured.firstName.value;
                primaryNamedDriver.person.middleName = primaryNamedInsured.middleName.value;
                primaryNamedDriver.person.lastName = primaryNamedInsured.lastName.value;
                primaryNamedDriver.person.suffix = primaryNamedInsured.suffix?.value?.code;
            }
        }
    }, [primaryNamedInsured.emailAddress1.value, primaryNamedInsured.firstName.value, primaryNamedInsured.lastName.value, primaryNamedInsured.middleName.value, primaryNamedInsured.publicID.value, primaryNamedInsured.suffix.value, productCode, submissionVM]);

    const syncPrimaryInsuredEmailWithVehicleOperators = useCallback(() => {
        if (!MLProductCodeUtil.isPersonalUmbrella(productCode) || !_.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicleOperators')) {
            return;
        }
        const vehicleOperators = _.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicleOperators.value')
        if (vehicleOperators && vehicleOperators.length) {
            const primaryNamedVehicleOperator = vehicleOperators.find((vehOp) => vehOp.relationshipToInsured === 'self');
            if (primaryNamedVehicleOperator && primaryNamedVehicleOperator.contact && (primaryNamedVehicleOperator.contact.publicID === primaryNamedInsured.publicID.value)) {
                primaryNamedVehicleOperator.emailAddress = primaryNamedInsured.emailAddress1.value;
            }
        }
    }, [primaryNamedInsured.emailAddress1.value, primaryNamedInsured.publicID.value, productCode, submissionVM]);

    const checkPhoneNumberEntered = useCallback(() => {
        return (_.isUndefined(primaryNamedInsured.cellNumber.value) &&
            _.isUndefined(primaryNamedInsured.homeNumber.value) &&
            _.isUndefined(primaryNamedInsured.workNumber.value));
    }, [primaryNamedInsured.cellNumber.value, primaryNamedInsured.homeNumber.value, primaryNamedInsured.workNumber.value]);

    const showPrimaryPhoneValidation = useCallback(() => {
        const primaryPhoneTypeValid = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.primaryPhoneType.aspects.valid');
        return !primaryPhoneTypeValid;
    }, [submissionVM]);

    const checkPhoneValidation = useCallback(() => {
        let hasError;
        const phoneNumEntered = checkPhoneNumberEntered();
        const primaryPhoneValidation = showPrimaryPhoneValidation();
        clearBlockAlerts('primaryPhone');

        if (phoneNumEntered || primaryPhoneValidation) {
            addErrorAlert(translator(messages.onePhoneMustBePrimary), 'primaryPhone')
            window.scrollTo(0, 0);
            return true;
        }
        return false;
    }, [checkPhoneNumberEntered, showPrimaryPhoneValidation]);

    const mapPhoneProperties = (contactTo, contactFrom) => {
        _.set(contactTo, 'primaryPhoneType.value', contactFrom.primaryPhoneType.value);
        _.set(contactTo, 'workNumber.value', contactFrom.workNumber.value);
        _.set(contactTo, 'homeNumber.value', contactFrom.homeNumber.value);
        _.set(contactTo, 'cellNumber.value', contactFrom.cellNumber.value);
        _.set(contactTo, 'tcpaConsentHomeNumber_ML.value', contactFrom.tcpaConsentHomeNumber_ML.value);
        _.set(contactTo, 'tcpaConsentHomeNumberText_ML.value', contactFrom.tcpaConsentHomeNumberText_ML.value);
        _.set(contactTo, 'tcpaConsentCellNumber_ML.value', contactFrom.tcpaConsentCellNumber_ML.value);
        _.set(contactTo, 'tcpaConsentCellNumberText_ML.value', contactFrom.tcpaConsentCellNumberText_ML.value);
        _.set(contactTo, 'tcpaConsentWorkNumber_ML.value', contactFrom.tcpaConsentWorkNumber_ML.value);
        _.set(contactTo, 'tcpaConsentWorkNumberText_ML.value', contactFrom.tcpaConsentWorkNumberText_ML.value);
    }

    const syncPhoneNumberWithAssociatedDriver = useCallback((contact) => {
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers')
        if (!MLProductCodeUtil.isPersonalAuto(productCode) || !drivers) {
            return;
        }

        if (drivers && drivers.length) {
            const associatedDriver = drivers.children.find((driver) => driver.person.publicID.value === contact.publicID.value);
            if (associatedDriver && associatedDriver.person) {
                const driverPerson = associatedDriver.person
                mapPhoneProperties(driverPerson, contact);
            }
        }
    }, [productCode, submissionVM]);

    const checkAvailability = useCallback((productType) => {
        const localDate = submissionVM.baseData.periodStartDate.value;
        const postalCode = _.get(submissionVM, 'baseData.policyAddress.postalCode.value');
        const state = _.get(submissionVM, 'baseData.policyAddress.state.value');
        const availabilityDto = {
            effectiveDate: localDate,
            productCode: productType,
            postalCode: postalCode.substring(0, 5),
            coveragePartType_ML: coverageType,
            stateCode_ML: state.code
        };
        return AvailabilityService.productAvailableBasedOnPostalCode(availabilityDto, authHeader);
    }, [coverageType, submissionVM, authHeader]);


    const _leadStartEvent = () => {
        MLTagManagerService.sendEvent('leadStart', {form: MLTagManagerService.getFormName()});
        updateWasAnalyticsTriggered(true);
    };

    const sendSubmissionCreatedEvent = (subVM) => {
        if (!_.isUndefined(subVM.quoteID.value)) {
            const request = {
                jobNumber: subVM.quoteID.value,
                sessionUUID: subVM.sessionUUID.value,
                eventType: MLCustomHistoryTypes.SubmissionCreated
            };
            MLHistoryService.createHistoryEvents([request], authHeader);
        }
    };

    const emailAddressBlurred = () => {
        clearBlockAlerts('electronicToPaper');
        setShowElectronicToPaperWarning(false);
        if ((_.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code') === 'electronic') && !_.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value')) {
            addWarningAlert(translator(messages.electronicToPaperWarning), 'electronicToPaper');
            setShowElectronicToPaperWarning(true);
            window.scrollTo(0, 0);
        }
    }
  
    const validateSpouseRequiredForMarriedPNI = useCallback(() => {
        clearBlockAlerts('spouseRequired');
        clearBlockAlerts('primaryMaritalStatusInvalid');
        clearBlockAlerts('secondaryMaritalStatusInvalid');

        if(isLLHOrLLC) return true;

        const pniMaritalStatus = submissionVM?.baseData?.primaryNamedInsured_ML?.maritalStatus?.value?.code;
        const secondaryNI = submissionVM?.baseData?.secondaryNamedInsured_ML?.value;
        const sniExists = !!secondaryNI;
        const sniRelationship = secondaryNI?.insuredRelationType_ML;
        const sniMaritalStatus = secondaryNI?.maritalStatus;

        if (pniMaritalStatus === 'M' && (!sniExists || sniRelationship !== 'spouse')) {
            addErrorAlert(translator(messages.spouseRequired), 'spouseRequired');
            window.scrollTo(0, 0);
            return false;
        }

        if (sniExists && sniRelationship === 'spouse' && sniMaritalStatus === 'S') {
            addErrorAlert(translator(messages.secondaryMaritalStatusInvalid), 'secondaryMaritalStatusInvalid');
            window.scrollTo(0, 0);
            return false;
        }

        if (
            pniMaritalStatus === 'S' && sniExists && sniRelationship === 'spouse') {
            addErrorAlert(translator(messages.primaryMaritalStatusInvalid), 'primaryMaritalStatusInvalid');
            window.scrollTo(0, 0);
            return false;
        }

        return true;
    }, [submissionVM,addErrorAlert,clearBlockAlerts,translator]);

    const validateData = useCallback((isReturnToQuote = false) => {
        setCurrentStepName();

        if (!isComponentValid) {
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid || getNumberOfAlerts(samePNIAndSNIAlertNameML) > 0) {
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            window.scrollTo(0, 0);
            return false;
        }

        if (isHOPModernProduct && isHomeowners && !validateSpouseRequiredForMarriedPNI()) {
            return false;
        }

        if (isReturnToQuote) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        }

        if (isHOPModernProduct && isHomeowners && (isPniRequiredInfoMissing)) {
            updateShowErrors(true);
            return false;
        }

        return true;
    }, [authHeader, currentStep.mlStepName, errorTimestamp, getNumberOfAlerts, isComponentValid, setCurrentStepName, submissionVM,validateSpouseRequiredForMarriedPNI]);

    const checkQuestionSetSync = (serviceCall) => {
        let updatePromise;
        if (questionSetSyncing && questionSetSyncPromise) {
            updatePromise = questionSetSyncPromise.then(() => {
                const promise = serviceCall();
                setTimeout(() => {
                    showProgressDialog(platformMessages.syncingQuestions, promise, true);
                }, 0);
                return promise;
            });
        } else {
            updatePromise = serviceCall();
            setTimeout(() => {
                showProgressDialog(platformMessages.syncingQuestions, updatePromise, true);
            }, 100);
        }
        setQuestionSetSyncing(true);
        setQuestionSetSyncPromise(updatePromise);
        return updatePromise;
    };

    const createPayloadToSyncQuestionSet = () => {
        var question;
        //populating false if user didnt ans the question
        var userResponse;
        if(farmersPrivacyNoticeValue === undefined || farmersPrivacyNoticeValue === null){
            userResponse = "false";
        }else{
            userResponse = farmersPrivacyNoticeValue;
        }
        if(submissionVM.baseData.productCode.value === "PersonalAuto"){
            _.set(submissionVM, "lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext", userResponse)
            question = _.get(submissionVM, "lobData.personalAuto.questionSets_ML.value.privacyDisclaimer");
        }else if(submissionVM.baseData.productCode.value === "PersonalUmbrella"){
            _.set(submissionVM, 'lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', userResponse);
            question = _.get(submissionVM, "lobData.personalUmbrella.value.privacyDisclaimer[0]");
        }else if(submissionVM.baseData.productCode.value === "HOPHomeowners"){
            _.set(submissionVM, 'lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', userResponse);
            question = _.get(submissionVM, "lobData.homeowners.value.privacyDisclaimer[0]");
        }
        return question;
    }

    const checkMVRQuestionNotAnswered = () => {
        if(submissionVM.baseData.productCode.value === "PersonalAuto" &&
            (submissionVM.lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext === undefined ||
                submissionVM.lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext === null)
        ){
            return true;
        }else if(submissionVM.baseData.productCode.value === "PersonalUmbrella" &&
            (submissionVM.lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === undefined ||
                submissionVM.lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === null)
        ){
            return true;
        }else if(submissionVM.baseData.productCode.value === "HOPHomeowners" &&
            (submissionVM.lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === undefined ||
            submissionVM.lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext === null)
        ){
            return true;
        }
        return false;
    }

    const syncQuestionSets = async () => {
        const aQuestionSetAnswersValue = createPayloadToSyncQuestionSet();
        const { code } = aQuestionSetAnswersValue;
        const quoteID = submissionVM.quoteID.value;

        const transformedQuestions = {};
        if (code && code === "PrivacyDisclaimer_ML") {
            if (code && code === "PrivacyDisclaimer_ML") {
                setQuestionSetSyncing(true); // show loading state

                try {
                    const updatedQuestions = await checkQuestionSetSync(() =>
                        LoadSaveService.syncQuestionSetML(quoteID, [aQuestionSetAnswersValue], authHeader)
                    );

                    const newVm = viewModelService.clone(submissionVM);

                    updatedQuestions.forEach((q) => {
                        transformedQuestions[q.code] = q;
                    });

                    if (code === "PrivacyDisclaimer_ML") {
                        if(submissionVM.baseData.productCode.value === "PersonalAuto"){
                            _.set(newVm, 'lobData.personalAuto.value.questionSets_ML.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext', transformedQuestions.PrivacyDisclaimer_ML.answers.FarmersPrivacyNotice_Ext);
                        }else if(submissionVM.baseData.productCode.value === "PersonalUmbrella"){
                            _.set(newVm, 'lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', transformedQuestions.PrivacyDisclaimer_ML.answers.FarmersPrivacyNotice_Ext);
                        }else if(submissionVM.baseData.productCode.value === "HOPHomeowners"){
                            _.set(newVm, 'lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', transformedQuestions.PrivacyDisclaimer_ML.answers.FarmersPrivacyNotice_Ext);
                        }
                    }
                    updateWizardData(newVm);
                } catch (error) {
                    console.error("Error syncing question set:", error);
                } finally {
                    setQuestionSetSyncPromise(null);
                    setQuestionSetSyncing(false);
                }
            }
        }
    }

    /**
     * Checks if the Primary Named Insured (PNI) or Secondary Named Insured (SNI) details
     * have changed compared to their initial values. If changes are detected, it resets
     * the values in the submissionVM to the initial ones and updates the wizard data.
     * 
     * @returns {boolean} - Returns true if any updates were made to PNI or SNI, otherwise false.
     */

    const isPNIUpdated = () => {
        const newPNI = submissionVM?.baseData?.primaryNamedInsured_ML?.value;
        const newSNI = submissionVM?.baseData?.secondaryNamedInsured_ML?.value;

        if (intialPNI?.publicID) {
            const isPNIDifferent =
                intialPNI.firstName !== newPNI?.firstName ||
                intialPNI.lastName !== newPNI?.lastName;

            if (isPNIDifferent) {
                if (intialPNI?.publicID !== newPNI?.publicID) {
                _.set(submissionVM,"baseData.primaryNamedInsured_ML.value",intialPNI);
                } else {
              _.set(submissionVM,"baseData.primaryNamedInsured_ML.firstName.value",intialPNI.firstName);
              _.set(submissionVM,"baseData.primaryNamedInsured_ML.lastName.value",intialPNI.lastName);
                }

                if (intialSNI?.publicID && newSNI) {
                    const isSNIDifferent =
                        intialSNI.firstName !== newSNI?.firstName ||
                        intialSNI.lastName !== newSNI?.lastName;

                    if (isSNIDifferent) {
                        if (intialSNI?.publicID !== newSNI?.publicID) {
                  _.set(submissionVM,"baseData.secondaryNamedInsured_ML.value",intialSNI);
                        } else {
                  _.set(submissionVM,"baseData.secondaryNamedInsured_ML.firstName.value",intialSNI.firstName);
                  _.set(submissionVM,"baseData.secondaryNamedInsured_ML.lastName.value",intialSNI.lastName);
                        }
                    }
                }

                updateWizardData(submissionVM);
                return true;
            }
        }

        return false;
    };

    const isPrimaryMaritalStatusChangedToMarried = (initialValue, updatedValue) => {
        return initialValue === 'S' && updatedValue === 'M';
    };

    const onNext = useCallback(async () => {

        clearBlockAlerts('pniUpdateInvalid');

        if (isLLHOrLLC && isDwellingDeededToBusinessOrTrust === true) {
            _.set(submissionVM, 'value.baseData.dwellingDeedInfo_Ext', dwellingDeedInfo);
            _.set(submissionVM, 'value.baseData.requireMaritalStatus_ML', true);
        }

        if (enablePNIValidation && isPNIUpdated()) {
            addWarningAlert(translator(messages.pniUpdateInvalid), 'pniUpdateInvalid');
            window.scrollTo(0, 0);
            return false;
        }

        if (isGPA && !returnToQuoteClicked) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Your Info Page', action: 'Your Info Page PUMB Submitted' });
                }
                else if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Your Info Page', action: 'Your Info Page HO Submitted' });
                }
                else {
                    PATrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Your Info Page', action: 'Your Info Page Submitted' });
                }

                checkUserCode(user);
            });
        }

        if (!wasAnalyticsTriggered) {
            _leadStartEvent();
        }

        setCurrentStepName();

        if (submissionVM.baseData.primaryNamedInsured_ML.publicID.value === submissionVM.baseData.accountHolder.publicID.value) {
            submissionVM.baseData.accountHolder.value = submissionVM.baseData.primaryNamedInsured_ML.value;
        }

        // Validating the Data before Validating the address
        try {
            const isDataValid = await validateData(returnToQuoteClicked);
            if (!isDataValid) {
                return false;
            }
        } catch (e) {
            updateShowErrors(true);
            setTimeout(() => {
                setErrorTimestamp(errorTimestamp + 1);
            }, 500);
            return false;
        }

        const validateAddressStatus = _.get(submissionVM, 'baseData.policyAddress.validateAddressStatus_ML.value');

        if (_.isUndefined(validateAddressStatus) || validateAddressStatus === false) {
            try {
                await MLAddressVerificationService.validateAddress(viewModelService, policyAddress, productCode);
            } catch (err) {
                setTimeout(()=>{
                    const addressField = document.querySelector('input[id^="addresslookupSearch"]')
                    if (addressField) {
                        window.scrollTo(0, 0);
                        addressField.focus();
                    }
                }, 500);
                return false;
            }
        }

        setDefaultPrimaryPhone();
        syncPrimaryInsuredNameAndEmailWithDrivers();
        syncPrimaryInsuredEmailWithVehicleOperators();

        _.set(submissionVM, 'baseData.primaryNamedInsured_ML.primaryNamedInsured_ML.value', true);
        const primaryNamedInsuredPrimaryAddr = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.primaryAddress.value', undefined);
        primaryNamedInsured.primaryAddress.value = primaryNamedInsuredPrimaryAddr || _.cloneDeep(_.get(submissionVM, 'baseData.policyAddress.value'));
        syncPhoneNumberWithAssociatedDriver(primaryNamedInsured);

        if (secondaryNamedInsuredValue) {
            syncPhoneNumberWithAssociatedDriver(secondaryNamedInsured);
            if (samePhone) {
                mapPhoneProperties(secondaryNamedInsured, primaryNamedInsured);
            }
        }

        if (showElectronicToPaperWarning === true && (_.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code') === 'electronic') && !_.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value')) {
            _.set(submissionVM, 'baseData.policyBillingDocCommPref_ML.value', 'paper');
            setShowElectronicToPaperWarning(false);
        }

        clearBlockAlerts('electronicToPaper');

        try {
            showProgressDialog(platformMessages.OneMomentPlease);
            let response;
            if (!returnToQuoteClicked) {
                try {
                    response = await checkAvailability(productCode);
                } catch (e) {
                    updateShowErrors(true);
                    setTimeout(()=>{
                        setErrorTimestamp(errorTimestamp+1);
                    }, 500);
                    return false;
                }

                if (!response.isAvailable) {
                    hideProgressDialog();
                    showErrorModal('', messages.productNotAvailableInState, messages.closeWindow);
                    return false;
                }
            }


            sendSubmissionCreatedEvent(submissionVM);
            if (!submissionVM.value.isQuoted()) {
                _.unset(submissionVM.value, 'bindData');
            }

            let nextStepName;
            const [accountSyncStepName, affiliationStepName, prefillStepName] = stepNames[productCode];

            if (returnToQuoteClicked) {
                showProgressDialog(platformMessages.saveSubmission, null, false, 0);
                const submissionData = await LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader);
                writeValue(submissionData, 'value');
                _.set(submissionVM, 'value', submissionData);
                updateWizardData(submissionVM);

                const zip = _.get(submissionVM, 'baseData.policyAddress.postalCode.value').substring(0, 5);
                history.push('/quoteentry', {quoteID: submissionVM.quoteID.value, postalCode: zip, returnToQuoteFlag: 'true'});
                return false;
            } else if (isBundleRateCapped(submissionVM.value) && submissionVM.value.isQuoted()) {
                // go to quoteDetails
                const index = _.findIndex(
                    steps,
                    ({ path }) => path === '/quote'
                );

                if (index > 0) {
                    const remainingSteps = _.slice(steps, index);
                    changeNextSteps(remainingSteps);
                }
                nextStepName = 'quoteDetails';
            } else if ((!!submissionVM.baseData.accountNumber.value || !submissionVM.baseData.accountHolder.accountInSync_ML.value)) {
                // If condition met, skip account syn page and save submission
                let pathName, nextStepNameSkipGroup;

                if (MLProductCodeUtil.isPersonalAuto(productCode)) {
                    const [paDiscrepanciesStepName] = stepNamesSkipGroup[productCode];
                    const groupIndex = steps.findIndex((step) => step.path === '/affiliation');
                    if (groupIndex > -1) {
                        nextStepNameSkipGroup = (MLProductCodeUtil.isPersonalAuto(productCode) && submissionVM.hvqQuoteID_ML.value) ? paDiscrepanciesStepName : affiliationStepName;
                        const remainingSteps = _.slice(steps, groupIndex);
                        changeNextSteps(remainingSteps);
                    } else {
                        pathName = (MLProductCodeUtil.isPersonalAuto(productCode) && !submissionVM.hvqQuoteID_ML.value) ? '/hvq-prefill-discrepancies-check' : '/accountSync';
                        nextStepNameSkipGroup = (MLProductCodeUtil.isPersonalAuto(productCode) && submissionVM.hvqQuoteID_ML.value) ? paDiscrepanciesStepName : prefillStepName;
                        const index = _.findIndex(
                            steps,
                            ({ path }) => path === pathName
                        );
                        if (index > 0) {
                            const remainingSteps = _.slice(steps, index + 1);
                            changeNextSteps(remainingSteps);
                        }
                    }
                } else {
                    pathName = '/accountSync';
                    nextStepNameSkipGroup = prefillStepName;
                    const index = _.findIndex(
                        steps,
                        ({ path }) => path === pathName
                    );
                    if (index > 0) {
                        const remainingSteps = _.slice(steps, index + 1);
                        changeNextSteps(remainingSteps);
                    }
                }

                if (!submissionVM.quoteID.value) {
                    showProgressDialog(platformMessages.createSubmission);
                    const beforePNIMarital = _.get(
                        submissionVM,
                        'baseData.primaryNamedInsured_ML.maritalStatus.value.code'
                    );
                    const beforeSNI= _.get(
                        submissionVM,
                        'baseData.secondaryNamedInsured_ML.value'
                    );
                    const submissionData = await LoadSaveService.createSubmission(submissionVM.value, authHeader);
                    _.set(submissionVM, 'value', submissionData);

                    if (isHOPModernProduct && isHomeowners && (isHomeOwnersPartialTypeHome || isHomeOwnersPartialTypeRental || isHomeOwnersPartialTypeCondo)) {
                        const afterPNIMarital = _.get(
                            submissionData,
                            'baseData.primaryNamedInsured_ML.maritalStatus'
                        );

                        const afterSNI = _.get(submissionData, 'baseData.secondaryNamedInsured_ML');
                        const afterSNIMarital = _.get(afterSNI, 'insuredRelationType_ML');
                        let messageToShow = null;
                        const isSingleToMarried =
                            isPrimaryMaritalStatusChangedToMarried(beforePNIMarital, afterPNIMarital);

                        if (isSingleToMarried) {
                            if (!beforeSNI && afterSNI && afterSNIMarital === 'spouse') {
                                messageToShow = messages.pniSingleSniNoSpouse;
                            } else {
                                messageToShow = messages.pniSingleNoSni;
                            }
                        }

                        if (messageToShow) {
                            _.set(submissionVM, 'tempData.qualificationMessage', messageToShow);
                            updateWizardData(submissionVM);
                        }
                    }

                    if (showFarmersPrivacyNoticerValue()) {
                        await syncQuestionSets();
                        //lock the question and make it readonly
                        const jsonData = { alreadyVisited: true };
                        MLPortalStorageService.store(submissionVM.quoteID.value, null, ML_STORAGE_KEY_ALREADY_VISITED, JSON.stringify(jsonData), authHeader);
                    }

                    ClausesUtil.getDependentClausesFromServer(
                        ClauseService,
                        _.get(submissionData, 'quoteID'),
                        authHeader
                    );

                } else {
                    let canSkipSave = steps.some((step) => step.mlStepName === nextStepNameSkipGroup && !!step.visited);
                    if (Array.isArray(nextStepNameSkipGroup)) {
                        canSkipSave = steps.some((step) => step.mlStepName === nextStepNameSkipGroup[0] && !!step.visited);
                    }
                    // save questionset if edit
                    if(showFarmersPrivacyNoticerValue()){
                        await syncQuestionSets();
                        //lock the question and make it readonly
                        const jsonData = {  alreadyVisited: true };
                        MLPortalStorageService.store(submissionVM.quoteID.value, null, ML_STORAGE_KEY_ALREADY_VISITED, JSON.stringify(jsonData), authHeader);
                    }
                    if (!canSkipSave) {
                        showProgressDialog(platformMessages.saveSubmission, null, false, 0);
                        const submissionData = await LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader);
                        writeValue(submissionData, 'value');
                        _.set(submissionVM, 'value', submissionData);
                    }
                }
                if (!submissionVM.value.isQuoted()) {
                    _.unset(submissionVM.value, 'bindData');
                }
                nextStepName = nextStepNameSkipGroup;
            } else {
                const hasAccountSyncStep = steps.some((step) => step.path === '/accountSync');
                if (!hasAccountSyncStep) {
                    const accountSyncIndex = _.findIndex(
                        wizardSteps, ({ path }) => path === '/accountSync'
                    );
                    const nextSteps = _.slice(wizardSteps, accountSyncIndex);
                    changeNextSteps(nextSteps);
                }
                nextStepName = accountSyncStepName;
            }
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, authHeader);

            if (!nextStepVisited()) {
                return submissionVM;
            }
            goNext();
        } catch (err) {
            console.error("error", err);
            if (err.baseError && err.baseError.includes('INVALID_PARAM')) {
                  return false;
            }
            const errorMessage_Permission = messages.permissionDifficulties;
            if(err.baseError && err.baseError.includes('InsufficientPermission')){
               showErrorModal('', errorMessage_Permission, messages.closeWindow, 'vueErrorMessagePadding');
               return false;
            }
            const DATABASE_BEAN_EXCEPTION = 'conflict';
            const errorMessage_DatabaseBeanConflict = messages.mlDatabaseBeanVersionConflictMessage
            if (err.baseError && err.baseError.includes(DATABASE_BEAN_EXCEPTION)) {
                showErrorModal('',errorMessage_DatabaseBeanConflict, messages.closeWindow, 'vueErrorMessagePadding');
                return false;
            }
            const displayableErrorMsg = MLErrorMessageUtil.retrieveDisplayableErrorMessage(err);
            const errorMessage = displayableErrorMsg || messages.technicalDifficulties;
            hideProgressDialog();
            showErrorModal('', errorMessage, messages.closeWindow, 'vueErrorMessagePadding');
            return false;
        } finally {
            hideProgressDialog();
        }
        return false;
    }, [isGPA, returnToQuoteClicked, wasAnalyticsTriggered, setCurrentStepName, submissionVM, setDefaultPrimaryPhone, syncPrimaryInsuredNameAndEmailWithDrivers, syncPrimaryInsuredEmailWithVehicleOperators, primaryNamedInsured, syncPhoneNumberWithAssociatedDriver, secondaryNamedInsuredValue, showElectronicToPaperWarning, clearBlockAlerts, authHeader, checkUserCode, viewModelService, policyAddress, productCode, secondaryNamedInsured, samePhone, showProgressDialog, validateData, sendSubmissionCreatedEvent, currentStep.mlStepName, nextStepVisited, goNext, checkAvailability, errorTimestamp, hideProgressDialog, showErrorModal, steps, writeValue, updateWizardData, history, changeNextSteps, wizardSteps]);


    const onReturnToQuoteClicked = useCallback(() => {
        returnToQuoteClicked = true;
        onNext();
    }, [onNext]);

    const getNextStepText = () => {
        let baseMsg;
        let boldMsg;
        const groupIndex = steps.findIndex((step) => step.path === '/affiliation');

        if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            if (groupIndex > -1) {
                baseMsg = messages.verifyGroupDiscounts;
                boldMsg = messages.groupDiscounts;
            } else {
                baseMsg = messages.baseWizardMessageNonRenters;
                boldMsg = messages.driversAndVehicles;
            }
        } else {
            baseMsg = messages.verifyGroupDiscounts;
            boldMsg = messages.discounts;
        }
        if (_.isUndefined(baseMsg) || _.isUndefined(boldMsg)) {
            return undefined;
        }

        return (
            <FormattedMessage
                {...baseMsg}
                values={{
                    groupdiscounts: (
                        <strong>{translator(boldMsg)}</strong>
                    )
                }}
            />
        );
    };

    const getPeriodStartDateErrorMessage = (periodStart) => {

                if(periodStart && periodStart?.value && getNewBusinessEffectiveDate){
            const formatPeriodStart = moment(MLLocalDateUtil?.localDate2Date(periodStart.value))
            const formatNewEffectiveDate = moment(MLLocalDateUtil?.localDate2Date(getNewBusinessEffectiveDate))
                        if(formatNewEffectiveDate.isAfter(formatPeriodStart)){
                const newBusinessEffectiveDate = formatNewEffectiveDate.format('MM/DD/YY')

                            return [translator(messages.periodStartDateError, {newBusinessEffectiveDate})]
            }

        }

        return periodStart?.aspects?.validationMessages;
    }

    const onDwellingDeedBusinessChange = useCallback((newValue) => {
        const clonedVM = viewModelService.clone(submissionVM);

        _.set(clonedVM, 'baseData.deedInfo_Ext.value', newValue === true);
        _.set(clonedVM, 'value.baseData.deedInfo_Ext', newValue === true);

        updateWizardData(clonedVM);

    }, [submissionVM, updateWizardData, viewModelService]);

    const onDwellingDeedInfoChange = useCallback((newValue) => {
        setDwellingDeedInfo(newValue);
    }, []);

    const getPrimaryNamedInsuredContent = useCallback(() => {
         if (isHomeownersAndLLHOrLLC && isDwellingDeededToBusinessOrTrust === true) {
             return translator(messages.firstPersonInControl);
         }
         return translator(messages.primaryNamedInsured);
     }, [
         isHomeownersAndLLHOrLLC,
         isDwellingDeededToBusinessOrTrust,
     ]);

     
    const pni = submissionVM?.baseData?.primaryNamedInsured_ML?.value;

    const pniMarital = pni?.maritalStatus;
    const pniEducation = pni?.educationLevel_ML;
    const pniOccupation = pni?.occupationType_Ext

    const dwellingDeedBusinessValue = submissionVM?.baseData?.deedInfo_Ext?.value

    const { isPniRequiredInfoMissing, maritalStatusError, educationError, occupationError, dwellingDeedError  } = useMemo(() => {

        const isEmpty = (v) => v === undefined || v === null || v === '';

        const dwellingDeedError = showErrors && isLLHOrLLC && (
            dwellingDeedBusinessValue === true ||
            dwellingDeedBusinessValue === 'true'
        ) && isEmpty(dwellingDeedInfo);

        const isPniRequiredInfoMissing = isHomeowners && (isEmpty(pniMarital) || isEmpty(pniEducation) || isEmpty(pniOccupation) || (isLLHOrLLC && dwellingDeedError));


        return {
            isPniRequiredInfoMissing,
            maritalStatusError:
                showErrors && isHomeowners && isEmpty(pniMarital),
            educationError:
                showErrors && isHomeowners && isEmpty(pniEducation),
            occupationError:
                showErrors && isHomeowners && isEmpty(pniOccupation),
                dwellingDeedError
        };
    }, [pniMarital, pniEducation, pniOccupation, dwellingDeedBusinessValue,dwellingDeedInfo,isLLHOrLLC,showErrors, isHomeowners]);

    const maritalStatusTooltip = useMemo(() => {
        if (!(isHOPModernProduct && isHomeowners)) {
            return undefined;
        }

        return {
            title: {
                id: 'ml.platform.inputs.contact-details.helpTextTitle',
                defaultMessage: 'What does this mean?'
            },
            text: {
                id: 'ml.platform.inputs.contact-details.helpText',
                defaultMessage:
                    'A civil union is defined as a state level legally recognized same-sex marriage. A domestic partner is a relationship between two individuals (same-or opposite-sex) who live together but are not married. Separated (living apart) is living in a separate household from a spouse but spouses are still legally married.'
            }
        };
    }, [isHOPModernProduct, isHomeowners]);
    
    const checkVisibility = () => {
        let showField = true;
        if(!isHOPModernProduct && isHomeowners){
            showField = false;
        }
        return showField;
    }

    const isEmptyMailingAddress = mailingAddress?.value
     && typeof mailingAddress.value === 'object'
     && Object.keys(mailingAddress.value).length === 0;

    const hasValidMailingAddress = (address) => {
        if (!address || Object.keys(address).length === 0) {
            return false;
        }
        if (
            Object.keys(address).length === 1 &&
            address.country === 'US'
        ) {
            return false;
        }
        return true;
    };
    
    const isAddressMatch = isEmptyMailingAddress || !hasValidMailingAddress(mailingAddress?.value)    //indicates the mailing and primary address are not yet different and visibility will be hidden
                        ? true : MLWizardUtil.areAddressesEqual(mailingAddress?.value, policyAddress?.value);                    

    const isSupportedProduct = !submissionVM.value.isLandlordCondo() && !submissionVM.value.isLandlordHome();
  
	const isFutureEffectiveDate = submissionVM?.value?.baseData?.periodStartDate?.year &&
          new Date(
              submissionVM?.value?.baseData?.periodStartDate?.year,
              submissionVM?.value?.baseData?.periodStartDate?.month,
              submissionVM?.value?.baseData?.periodStartDate?.day
          ) > new Date();

	const isChangeMailingAddressQuestionVisible = () => {
        return isFutureEffectiveDate && isSupportedProduct && !isAddressMatch;
    };

    // Default changeMailingAddQuestion_Ext to false when the question becomes visible
    useEffect(() => {
        if (isChangeMailingAddressQuestionVisible() && _.isUndefined(changeMailingAddressValue)) {
            const clonedSubmissionVM = _.clone(submissionVM);
            _.set(clonedSubmissionVM, 'baseData.changeMailingAddQuestion_Ext.value', false);
            updateWizardData(clonedSubmissionVM);
        }
    }, [isFutureEffectiveDate, isSupportedProduct, isAddressMatch]);

    const updateChangeMailingAddress = useCallback((newValue) => {
        const clonedSubmissionVM = _.clone(submissionVM);
        _.set(clonedSubmissionVM, 'baseData.changeMailingAddQuestion_Ext.value', newValue);
        updateWizardData(clonedSubmissionVM);
    }, [submissionVM, updateWizardData]);
  
    const overrideProps = {
        pniOccupation: {
            availableValues: occupationtypelist,
            visible: isHOPModernProduct && isHomeowners,
            showErrors,
            validationMessages: occupationError ? [translator(messages.fieldRequired)] : []
        },
        pniEducationLevel: {
            visible:isHOPModernProduct && isHomeowners,
            showErrors,
            validationMessages: educationError ? [translator(messages.fieldRequired)] : []
        },
        maritalStatusML: {
            visible: isHOPModernProduct && isHomeowners,
            showErrors,
            validationMessages: maritalStatusError ? [translator(messages.fieldRequired)] : [],
            tooltip: maritalStatusTooltip,
        },
        policyNamedInsuredCandidatesComponent: {
            visible: pniPublicIdInitialisedML,
            submissionVM,
            initPublicID: _.get(submissionVM, 'baseData.primaryNamedInsured_ML.publicID.value'),
            setNamedInsured: setPrimaryNamedInsuredML,
            namedInsuredCandidates,
            loadNamedInsuredCandidates,
            isPrimaryNamedInsured: true
        },
        bypassCreditOrdering: {
            visible: isBypassCreditOrderingVisible
        },
        bypassCreditOrderingCheckbox: {
            value: _.get(submissionVM, 'baseData.bypassCreditOrdering_Ext.value'),
            onValueChange: onChangeBypassCreditOrdering,
        },
        nameDetailsComponent: {
            personVM: primaryNamedInsured,
            onValidate,
            showValidationErrors: showErrors,
            onModelChange: writeValue,
            layout: 'ML-Name-Default'
        },
        stickyContinueSection: {
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(),
            onNext,
            showReturnToQuote,
            isSticky: MLMultiLobsDataHolderService?.hasCompletedStep(currentStep?.mlStepName)
        },
        nextDescription: {
            content: getNextStepText()
        },
        choosePrimaryNamedInsuredContainer: {
            visible: !!_.get(submissionVM, 'baseData.accountNumber.value')
        },
        dobContainer: {
            visible: showDateOfBirth
        },
        addressComponent: {
            onValueChange: writeValue,
            sectionLabel: MLProductCodeUtil.isHomeOwners(productCode) ? translator(messages.propertyAddressLabel) : translator(messages.insuredAddressLabel),
            initialLockStateCity: false,
            value: _.get(submissionVM, 'baseData.policyAddress'),
            showValidationErrors: showErrors
        },
        mailingAddresslookup: {
            id: 'mailingAddresslookup',
            sameMailingAddress: sameMailingAddressValue,
            onValueChange: writeValue,
            initialLockStateCity: false,
            value: mailingAddress,
            showValidationErrors: showErrors
        },
        mailingAddressDetailsContainer: {
            visible: !sameMailingAddressValue
        },
        mailingAddressRadioButton: {
            visible: addressLine1 && city,
            onValueChange: updateMailingAddress,
            value: sameMailingAddressValue
        },
        updateInfoAboveText: {
            content: getPrimaryNamedInsuredContent()
        },
        dwellingDeedBusinessRadioButton: {
            visible: isHOPModernProduct && isLLHOrLLC,
            onValueChange: onDwellingDeedBusinessChange,
        },
        deedOrTitle: {
            visible: isHOPModernProduct &&isLLHOrLLC && (isDwellingDeededToBusinessOrTrust === true || isDwellingDeededToBusinessOrTrust === 'true'),
            onValueChange: onDwellingDeedInfoChange,
            value: dwellingDeedInfo,
            showErrors,
            validationMessages: dwellingDeedError ? [translator(messages.fieldRequired)] : []
        },
        farmersPrivacyNoticeContainer: {
            visible: isMVRCacheQuestionVisible && showFarmersPrivacyNoticerValue() && checkVisibility() //lob PA, HO or UMB
        },
        farmersPrivacyNoticeRadioButton: {
            visible: isMVRCacheQuestionVisible && showFarmersPrivacyNoticerValue(), //lob PA, HO or UMB
            onValueChange: updateFarmersPrivacyNotice,
            value: farmersPrivacyNoticeValue,
            disabled: pageAlreadyVisited && !checkMVRQuestionNotAnswered()
        },
        quoteAssistContainer: {
            visible: showQuoteAssistQuestion(),
        },
        quoteAssistRadioButton: {
            visible: showQuoteAssistQuestion(),
            onValueChange: updateQuoteAssist,
            value: quoteAssist,
        },
        periodStartDate: {
            showValidationErrors: showErrors,
            validationMessages: getPeriodStartDateErrorMessage(_.get(submissionVM, 'baseData.periodStartDate'))

        },
        priorAddressDetailsContainer: {
            visible: !isLLHOrLLC && priorMailingAddressValue
        },
        priorAddressRadioButton: {
            onValueChange: updatePriorAddress,
            value: priorMailingAddressValue,
            visible: !isLLHOrLLC
        },
        priorAddresslookup: {
            id: 'priorAddresslookup',
            onValueChange: writeValue,
            initialLockStateCity: false,
            value: priorAddress,
            showValidationErrors: showErrors,
            visible: !isLLHOrLLC
        },
        primaryInsuredEditContactDetails: {
            accountContactDetailsVm: _.get(submissionVM, 'baseData.primaryNamedInsured_ML'),
            isAgent: true,
            showEmailScript: false,
            writeValue,
            path: 'baseData.primaryNamedInsured_ML',
            showValidationErrors: showErrors,
            updateContactVM,
            onValidate,
            isSkipping: isSkipping && skipOnResumeIf(),
            canEditCommFields,
            originalContactDetails: originalPNIContactDetails,
            newPrimaryNamedInsuredClicked,
            setNewPrimaryNamedInsuredClicked,
            emailAddressBlurred,
            validateEmailAddress
        },
        mailingAddressContainer: {
            className: !sameMailingAddressValue ? 'vertical-spacing-40' : ''
        },
        priorAddressContainer: {
            className: priorMailingAddressValue ? 'vertical-spacing-40' : ''
        },
        addSecondNamedInsured: {
            submissionVM,
            updateWizardData,
            writeValue,
            samePhone,
            setSamePhone,
            isAgent: true,
            doContactsHaveSamePhone,
            namedInsuredCandidates,
            onValidate,
            showValidationErrors: showErrors,
            visible: !isSkipping || (isSkipping && !skipOnResumeIf()), // to avoid tcpaConsent being overriden to undefined in SecondaryNamedInsuredComponent when skipping this page,
            canEditCommFields,
            loadNamedInsuredCandidates,
            validateEmailAddress,
            isModernProduct : isHOPModernProduct,
            pniPriorAddress: priorAddress,
            isSecondaryNamedInsured : true
        },
        mlScriptComponent: {
        visible:isModernProduct && !_.isEmpty(scriptML),
            mlScript: scriptML,
        },

        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: true
        },
        changeMailingAddressContainer :{
            visible: isChangeMailingAddressQuestionVisible()
        },
        changeMailingAddressRadioButton: {
            value: changeMailingAddressValue,
            onValueChange: updateChangeMailingAddress
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            onAddNewName: addNewContact,
            onNext
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            mlPolicyNamedInsuredCandidatesComponent: MLPolicyNamedInsuredCandidatesComponent,
            mlNameDetailsComponent: MLNameDetailsComponent,
            mlEditContactDetailsComponent: MLEditContactDetailsComponent,
            secondaryNamedInsuredComponent: SecondaryNamedInsuredComponent,
            mlScriptComponent: MLScriptComponent,
            MLAlertGroupComponent
        }
    };

    return (
        <WizardPage
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showCancel={false}
            showNext={!nextStepVisited()}
            showReturnToQuote={showReturnToQuote && canRequote}
            disableReturnToQuote={!canRequote}
            onReturnToQuote={onReturnToQuoteClicked}
            updateWizardData={updateWizardData}
            history={history}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={getNextStepText()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyContinueSection'
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                showErrors={showErrors}
                componentMap={resolvers.resolveComponentMap}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

GatewayYourInfoPage.propTypes = wizardProps;
export default withRouter(GatewayYourInfoPage);
